const EDGE_FUNCTION_URL = `${process.env.NEXT_PUBLIC_SUPABASE_URL}/functions/v1/send-booking-email`;
const ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? '';

async function callEmailFunction(payload: Record<string, unknown>): Promise<void> {
  try {
    const res = await fetch(EDGE_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${ANON_KEY}`,
      },
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      console.error('[EmailService] Failed to send email:', err);
    }
  } catch (err) {
    console.error('[EmailService] Network error:', err);
  }
}

export interface BookingConfirmationPayload {
  clientName: string;
  clientEmail: string;
  bookingId: string;
  service: string;
  vehicleSize: string;
  vehicle: string;
  date: string;
  time: string;
  addons: { name: string; price: number }[];
  subtotal: number;
  depositPaid: number;
  paymentType: 'deposit' | 'full';
}

export interface RescheduleAlertPayload {
  clientName: string;
  clientEmail: string;
  bookingId: string;
  service: string;
  oldDate: string;
  oldTime: string;
  newDate: string;
  newTime: string;
}

export interface ReminderPayload {
  clientName: string;
  clientEmail: string;
  bookingId: string;
  service: string;
  vehicle: string;
  date: string;
  time: string;
  balanceDue: number;
  paymentStatus: string;
}

export async function sendBookingConfirmation(payload: BookingConfirmationPayload): Promise<void> {
  await callEmailFunction({ type: 'booking_confirmation', ...payload });
}

export async function sendRescheduleAlert(payload: RescheduleAlertPayload): Promise<void> {
  await callEmailFunction({ type: 'reschedule_alert', ...payload });
}

export async function sendReminderEmail(payload: ReminderPayload): Promise<void> {
  await callEmailFunction({ type: 'reminder', ...payload });
}
